<template>
	<div class="textContent" style="position: relative" :class="{arabicFont: contentData.useArabicFont}">
		<div v-if="authenticated && !dragging">
			<label>Text</label>
			<tinymce style="border:dotted;" v-model="contentData.text" api-key="1leh8qlbidx8ng7nl5hypnwglmn1lw6axqskedv8uyu7g6dw" :init="tinymceOptions(index)"></tinymce>
			<div class="form-check">
				<input type="checkbox" v-model="contentData.useArabicFont" class="form-check-input" id="exampleCheck1">
				<label class="form-check-label" for="exampleCheck1">Use arabic font</label>
			</div>
		</div>
		<div class="deskPad" v-if="!authenticated" v-html="contentData.text">
		</div>
	</div>
</template>

<script>
	import $ from 'jquery';
	import 'bootstrap/dist/js/bootstrap';
	export default {
		name: "textcontent-component",
		props: ['contentData', 'index', 'hide', 'dragging', 'authenticated'],
		data: function () {
			return {
				colours: "",
				editing: false,
				newColour: ''
			};
		},
		computed: {
			backgroundColour() {
				return this.contentData.backgroundColor;
			},
			contentStart() {
				var element = $("<div></div>").append(this.contentData.text);
				var text = element.text();
				return text.substring(0, 100);
			}
		},
		methods: {
			toggleHide() {
				this.$emit('toggle-hide');
			},
			deleteSection() {
				this.$emit('delete')
				this.pod.sections.splice(index, 1);
			},
			chooseBackground() {
				this.newColour = this.contentData.backgroundColor;
				$('#backgroundModal_' + this.index).modal('show');
			},
			updateColour: function (value) {
				this.newColour = value.hex;
			},
			saveBackground() {
				this.contentData.backgroundColor = this.newColour;
				$('#backgroundModal_' + this.index).modal('hide');
			},
			tinymceOptions(id) {
				return {
					id: id,
					plugins: ["link", "fullscreen", "spellchecker", "code", "textcolor"],
					toolbar:
						"undo redo | bold italic underline forecolor | alignleft aligncenter alignright alignjustify | bullist numlist | formatselect | link | code",
					menubar: false,
					statusbar: false,
					images_upload_url: "/Home/SaveUploadedFile",
					automatic_uploads: true,
					paste_data_images: true,
					setup: function (editor) {
						editor.on("init", function (e) {
							console.log("wysiwyg initialised");
						});
					},
					inline: true
				};
			}
		}
	};</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
	.textContent {
		padding: 20px;
	}

	@media only screen and (min-width: 992px) {
		.deskPad {
			margin-left: 100px;
			margin-right: 100px;
		}
	}

	.bottom-right {
		position: absolute;
		bottom: 16px;
		right: 16px;
	}
</style>
